/**
 * meta中 role       为角色权限，决定用户是否有权限访问该路由
 * keepAlive        为缓存选项，如果该路由需要缓存，值设为true
 * requiresAuth     验证登录权限
 * title            页面标题
 */

import Nofound from '.././components/page/Nofound.vue'
import Iframe from '.././components/page/Iframe.vue'

// user    role:0
import Index from './../views/index.vue' // 首页
import interaction from './../views/interaction.vue' // 互动交流
import interaction_letter from './../views/interaction_letter.vue' // 互动交流写信
import xqNews from './../views/xqNews.vue' // 新区要闻
import xqNews_detail from './../views/xqNews_detail.vue' // 新区要闻详情
import leaderInfo from './../views/leaderInfo.vue' // 领导信息
import leaderInfo_detail from './../views/leaderInfo_detail.vue' // 领导信息详情
import gw_detail from './../views/gw_detail.vue' // 顾问团队详情
import ztzl from './../views/ztzl.vue' // 专题专栏
import wz_map from './../views/wz_map.vue' // 网站地图
import sea_result from './../views/sea_result.vue' // 搜索查询
import video from './../views/videoList.vue' // 视频列表
import videoPhone from './../views/videoList_phone.vue' // 视频列表手机端
import videoKanPhone from './../views/videoKan_phone.vue' // 视频列表手机端
import videoPlayPhone from './../views/videoPlay_phone.vue' // 视频列表手机端
import videoKan from './../views/videoKan.vue' // 新媒看新区
import videoPlay from './../views/videoPlay.vue' // 视频播放
import xqNews_sanji from './../views/xqNews_sanji.vue' // 三级分类列表
import showNews from './../views/showNews.vue' // 其他新闻列表
import ztzl_fk from './../views/ztzl_fk.vue' // 疫情防控

export default [
    // 内容的模板
    {
        path: '/',
        component: Iframe,
        meta: {
            requiresAuth: false
        },
        children: [
            // 首页
            {
                path: '/',
                name: 'home',
                component: Index,
                meta: {
                    requiresAuth: false,
                    title: ' 河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 互动交流
            {
                path: '/interaction',
                name: 'interaction',
                component: interaction,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: true
                }
            },
            // 互动交流写信
            {
                path: '/interaction_letter',
                name: 'interaction_letter',
                component: interaction_letter,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: true
                }
            },
            // 疫情防控
            {
                path: '/ztzl_fk',
                name: 'ztzl_fk',
                component: ztzl_fk,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: true
                }
            },
            // 新区要闻
            {
                path: '/xqNews',
                name: 'xqNews',
                component: xqNews,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: true
                }
            },
            // 新区要闻详情
            {
                path: '/xqNews_detail',
                name: 'xqNews_detail',
                component: xqNews_detail,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 领导信息
            {
                path: '/leaderInfo',
                name: 'leaderInfo',
                component: leaderInfo,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: true
                }
            },
            // 领导信息详情
            {
                path: '/leaderInfo_detail',
                name: 'leaderInfo_detail',
                component: leaderInfo_detail,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 顾问团队详情
            {
                path: '/gw_detail',
                name: 'gw_detail',
                component: gw_detail,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 专题专栏
            {
                path: '/ztzl',
                name: 'ztzl',
                component: ztzl,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 网站地图
            {
                path: '/wz_map',
                name: 'wz_map',
                component: wz_map,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 查询搜索
            {
                path: '/sea_result',
                name: 'sea_result',
                component: sea_result,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 视频列表
            {
                path: '/video',
                name: 'video',
                component: video,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 视频列表手机端
            {
                path: '/videoPhone',
                name: 'videoPhone',
                component: videoPhone,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 新媒看新区手机端
            {
                path: '/videoKanPhone',
                name: 'videoKanPhone',
                component: videoKanPhone,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 新媒看新区手机端
            {
                path: '/videoPlayPhone',
                name: 'videoPlayPhone',
                component: videoPlayPhone,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 新媒看新区
            {
                path: '/videoKan',
                name: 'videoKan',
                component: videoKan,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 视频列表
            {
                path: '/videoPlay',
                name: 'videoPlay',
                component: videoPlay,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 三级分类列表
            {
                path: '/xqNews_sanji',
                name: 'xqNews_sanji',
                component: xqNews_sanji,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: false
                }
            },
            // 其他新闻列表
            {
                path: '/showNews',
                name: 'showNews',
                component: showNews,
                meta: {
                    requiresAuth: false,
                    title: '河北衡水高新技术产业开发区管理委员会',
                    role: 0,
                    keepAlive: true
                }
            },
            // 其它404
            // {
            //     path: '*',
            //     name: 'home',
            //     component: Index,
            //     meta: {
            //         requiresAuth: false,
            //         title: ' 河北衡水高新技术产业开发区管理委员会',
            //         role: 0,
            //         keepAlive: true
            //     }
            // }
            {
                path: '*',
                name: 'noaccess',
                component: Nofound,
                meta: {
                    requiresAuth: true,
                    pageTitle: '404'
                }
            }
        ]
    }
]
